import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { isRTL } = useTranslation();
  
  return (
    <footer className="bg-gray-800 text-white py-6 mt-12">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-2 rtl:space-x-reverse mb-2">
            <span className="text-2xl">💰</span>
            <span className="text-lg font-semibold">
              {isRTL ? 'مخطط الميزانية' : 'Budget Planner'}
            </span>
          </div>
          
          <p className="text-gray-400 text-sm mb-4">
            {isRTL 
              ? 'تطبيق ثنائي اللغة لإدارة الميزانية الشخصية' 
              : 'Bilingual Personal Budget Management App'
            }
          </p>
          
          <div className="border-t border-gray-700 pt-4">
            <p className="text-gray-500 text-sm">
              © 2025 Mohammed Almashwaly. {isRTL ? 'جميع الحقوق محفوظة' : 'All rights reserved'}.
            </p>
            <p className="text-xs text-gray-600 mt-1">
              {isRTL ? 'صُنع بـ' : 'Made with'} ❤️ {isRTL ? 'باستخدام' : 'using'} React & TailwindCSS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;